import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=6d7ee080&scoped=true"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=6d7ee080&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7ee080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7ee080')) {
      api.createRecord('6d7ee080', component.options)
    } else {
      api.reload('6d7ee080', component.options)
    }
    module.hot.accept("./ItemView.vue?vue&type=template&id=6d7ee080&scoped=true", function () {
      api.rerender('6d7ee080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/ItemView.vue"
export default component.exports